import moment from "moment";

export const dateFormat = (date) => {
    return moment(date).format("DD MMMM YYYY")
}

export const toRupiahs = (value) => {
    const formatter = Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
    });

    return formatter.format(value);
}

export const safeURL = (url) => {
    if (!/^https?:\/\//i.test(url)) {
        return 'https://' + url;
    }
}